import * as React from 'react';
import { Reference, ReferenceProps } from 'react-popper';
import { UnsafeSpreadProps } from '@tanium/coreui-utils';
import { ReferenceChildren } from './types';

export interface TooltipReferenceProps extends UnsafeSpreadProps {
  /**
   * The component to be tooltipped. This render prop requires the inner component to assign the
   * supplied ref to itself. This means that functional components cannot receive tooltips because
   * they do not have instances with refs.
   */
  children: ReferenceChildren;
}

/**
 * Holds a reference to the component that should be wrapped with a tooltip.
 */
export const TooltipReference = ({
  children,
  __UNSAFE_ADDITIONAL_PROPS__,
}: TooltipReferenceProps) => (
  <Reference {...__UNSAFE_ADDITIONAL_PROPS__}>{children as ReferenceProps['children']}</Reference>
);
